import React, { Component } from "react";
import { Modal, message, Form, InputNumber, Input, Icon, Button } from "antd";
import { API } from "@/http/api";
import http from "@/http";
// import "./newUser.less";

class newUser extends Component {
    state = {

    };

    componentDidMount() {
        this.initUI();
    }
    resetFields = () => {
        this.props.form.setFieldsValue({
            userName: '',
            mobile: '',
            password: '',
            email: '',
            organizationCode: '',
            organizationName: '',
        });
    }
    initUI() {
        if (this.props.type == 0) {
            this.resetFields();
        } else {
            let data = this.props.data;

            if (data) {//有值 表示 是编辑。 没有data表示 是新增
                var newData = { ...data };
                this.props.form.setFieldsValue(newData);
            }
        }

    }
    doAddEdit = formData => {
        if (this.props.type == 0) {
            const config = {
                api: API.saveAuthUser,
                data: formData
            };
            http(config).then(res => {
                if (res.code == 200) {
                    this.handleCancel();
                    this.resetFields();
                    message.success("新增成功")
                    this.props.getUserlist();
                }
            });
        } else {
            formData.userId = this.props.id
            const config = {
                api: API.editAuthUser,
                data: formData
            };
            http(config).then(res => {
                if (res.code == 200) {
                    message.success("修改成功")
                    this.handleCancel();
                    this.resetFields();
                    this.props.getUserlist();
                }
            });
        }

    };

    handleCancel = () => {
        this.props.cancelDialog();
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                if (this.props.type == 0) {
                    if (!values.password) {
                        message.error("密码不能为空")
                        return;
                    }
                }
                let fieldsObject = this.props.form.getFieldsValue();
                this.doAddEdit({ ...fieldsObject });
            }
        });
    };
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                title={this.props.type == 0 ? "新增用户" : "修改用户"}
                visible={true}
                okText="确定"
                cancelText="取消"
                closable={false}
                maskClosable={false}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width={500}
                footer={[]}
            >
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item label="姓名">
                        {getFieldDecorator("userName", {
                            rules: [
                                { required: true, message: "请输入姓名" },
                            ]
                        })(<Input placeholder="请输入(最长50位)" maxLength={50} />)}
                    </Form.Item>
                    <Form.Item label="手机号码">
                        {getFieldDecorator("mobile", {
                            rules: [{ required: true, message: "请输入您的账号/手机号码" },
                            { pattern: /^1[0-9]{10}$/, message: "请输入正确的手机号码" }]
                        })(
                            <Input placeholder="请输入手机号码" />
                        )}
                    </Form.Item>
                    <Form.Item >
                        <div style={{ color: '#333', fontSize: '12px', marginBottom: '5px' }}>
                            密码
                            {
                                this.props.type == 0 ?
                                    <span style={{ color: '#E94437', marginLeft: '5px' }}>*</span>
                                    : ""
                            }

                        </div>
                        {getFieldDecorator("password", {
                            rules: [
                                { pattern: /^.{6,16}$/, message: "密码最少6位最多16位" }]
                        })(
                            <Input.Password placeholder="密码" minLength={6} />
                        )}
                    </Form.Item>
                    <Form.Item label="电子邮箱">
                        {getFieldDecorator("email", {
                            rules: []
                        })(
                            <Input placeholder="请输入电子邮箱" />
                        )}
                    </Form.Item>
                    <Form.Item label="企业统一信用代码">
                        {getFieldDecorator("organizationCode", {
                            rules: [
                                { required: true, message: "请输入企业统一信用代码" },
                            ]
                        })(<Input placeholder="请输入企业统一信用代码" />)}
                    </Form.Item>
                    <Form.Item label="企业名称">
                        {getFieldDecorator("organizationName", {
                            rules: [
                                { required: true, message: "请输入企业名称" },
                            ]
                        })(<Input placeholder="请输入企业名称" />)}
                    </Form.Item>

                    <div className="btn-group">
                        <Button type="primary" htmlType="submit">
                            提交
                        </Button>
                        <Button onClick={this.handleCancel} size="large">
                            取消
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }
}

export default Form.create({ name: "newUser" })(newUser);
